import './App.css';
import './MediaQueries.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop';
import Home from './Pages/Home';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Pages/About';
import Calculator from './Pages/Calculator';
import Applications from './Pages/Applications';
import NotFound from './Pages/NotFound';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import ContactUs from './Pages/ContactUs';
import ProductsPg from './Pages/ProductsPg';
import WhatsAppButton from './Components/Whatsapp';

function App() {
  return (
  <>
  <BrowserRouter>
     <ScrollToTop />
     <WhatsAppButton />
     <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/products/:slug" element={<ProductsPg />} />
        <Route path="/calculator" element={<Calculator />} />
        <Route path="/applications" element={<Applications/>} />
        <Route path="/contact-us" element={<ContactUs/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
      <Footer />
      </BrowserRouter>
  </>
  );
}

export default App;
